const API_URL =
  process.env.NODE_ENV === "production"
   ?"/api" // ✅ HTTPS for production
    : "http://localhost:5000/api"; // Local development server

export default API_URL;
  